import { defineMessages } from 'react-intl'

export const strings = defineMessages({
  viewDetails: {
    id: 'FeedItem.viewDetails',
    defaultMessage: 'See Message',
  },
  hideDetails: {
    id: 'FeedItem.hideDetails',
    defaultMessage: 'Hide',
  },
})
